import e from "./_getByteLength.js";
function t(t) {
  return new Uint8Array(t.buffer || t, t.byteOffset || 0, e(t));
}
export { t as default };